// import { useQuery } from '@tanstack/react-query';
// import React from 'react'
// import {auth} from '../../components/Auth/Auth'

// const GetDeviceLogs = async (deviceId) => {
//     const user = auth.currentUser;
//     if(!user){
//   throw new Error('No authenticated user found');
// }


//     if(!deviceId){
//         return null
//     }

//     const token = await user.getIdToken();


//     const response = await fetch(`${import.meta.env.VITE_API_URL}/api/v1/marketing/${deviceId}`,{
//         headers:{
//     'Authorization': `Bearer ${token}`,
//     'Content-Type': 'application/json',

//   }

//     });
//     if(!response.ok){
//         throw new Error('Network response was not ok');
//     }
//     return response.json();  
// }


// export const useDeviceLogs = (deviceId) =>{
//     const {data,isPending,error,refetch } = useQuery({
//             queryKey: ['deviceLogsInfo', deviceId],
//             queryFn: () => GetDeviceLogs(deviceId),
//             enabled: !!deviceId,
//         })
//         return {data,isPending,error,refetch}

// }


import { useQuery } from "@tanstack/react-query";
import React from "react";
import { auth } from "../../components/Auth/Auth";

const GetDeviceLogs = async (deviceId) => {
  // Get the currently authenticated user.
  const user = auth.currentUser;

  // Stop the request when there is no authenticated user.
  if (!user) {
    throw new Error("No authenticated user found");
  }

  // Stop the request when there is no device ID.
  if (!deviceId) {
    return null;
  }

  // Get the Firebase authentication token.
  const token = await user.getIdToken();

  // Encode the device ID so special characters are safe in the URL.
  const encodedDeviceId = encodeURIComponent(deviceId);

  // Request the log summary for the selected device.
  const response = await fetch(
    `${import.meta.env.VITE_API_URL}/api/v1/marketing/device/${encodedDeviceId}/device`,
    {
      headers: {
        // Send the Firebase authentication token to the backend.
        Authorization: `Bearer ${token}`,

        // Tell the backend that the request uses JSON.
        "Content-Type": "application/json",
      },
    }
  );

  // Throw an error when the backend request fails.
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  // Convert the response body to JSON.
  return response.json();
};

export const useDeviceLogs = (deviceId) => {
  // Load and cache the logs for the selected device.
  const { data, isPending, error, refetch } = useQuery({
    queryKey: ["deviceLogsInfo", deviceId],
    queryFn: () => GetDeviceLogs(deviceId),
    enabled: !!deviceId,
  });

  // Return the query data and status.
  return { data, isPending, error, refetch };
};



